import {
	GET_LICENSE_LIST,
	GET_LICENSE_LIST_FAIL,
	GET_LICENSE_LIST_SUCCESS,
	LICENSE_UPDATE_PATCH,
	LICENSE_UPDATE_PATCH_ERROR,
	LICENSE_UPDATE_PATCH_SUCCESS,
	LICENSE_UPDATE_POST,
	LICENSE_UPDATE_POST_FAIL,
	LICENSE_UPDATE_POST_SUCCESS,
	LICENSE_UPDATE_RESET,
	UPLOAD_LICENSE,
	UPLOAD_LICENSE_FAIL,
	UPLOAD_LICENSE_RESET,
	UPLOAD_LICENSE_SUCCESS,
	LICENSE_EXPIRING,
	GET_SYSTEM_CONFIG_LIST_SUCCESS,
	GET_SYSTEM_CONFIG_LIST_FAIL,
	LICENSE_DETAILS_POPUP_REQUEST,
	LICENSE_DETAILS_POPUP_SUCCESS,
	LICENSE_DETAILS_POPUP_FAILURE,
	LICENSE_UPDATE_POPUP_REQUEST,
	LICENSE_UPDATE_POPUP_SUCCESS,
	LICENSE_UPDATE_POPUP_FAILURE
} from '../../constants/licenseManagement/licenseConstants';

/**
 * Reducer function for managing the license list state.
 *
 * @param {object} state - Current state of the license list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const licenseListReducer = (
	state = { 
		licenses: {}, 
		loading: false , 
		expiringAlertShown: false,
		licenseDetails : {
			licenseList: [],
			loading: false,
			error : null
		},
		licenseUpdateResponse : {
			licenseUpdateList : [],
			loading: false,
			error : null
		}
	},
	action
) => {
	switch (action.type) {
		case GET_LICENSE_LIST:
			return {
				...state,
				loading: true,
				licenses: {},
			};
		case GET_LICENSE_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				licenses: action.payload,
			};
		case GET_LICENSE_LIST_FAIL:
			return {
				...state,
				loading: false,
				licenseGetError: action.payload,
			};
		case LICENSE_EXPIRING:
			console.log("action.type", action.type)
			return {
				...state,
				expiringAlertShown: action.type
			};
		case GET_SYSTEM_CONFIG_LIST_SUCCESS:
			return {
				...state,
				systemConfigLoading: false,
				systemConfigData: action.payload,
			};
		case GET_SYSTEM_CONFIG_LIST_FAIL:
			return {
				...state,
				systemConfigLoading: false,
			};
		case LICENSE_DETAILS_POPUP_REQUEST:
			return {
				...state,
				licenseDetails: {
					licenseList: [],
					loading : true,
					error: null
				}
			};
		case LICENSE_DETAILS_POPUP_SUCCESS:
			return {
				...state,
				licenseDetails: {
					loading : false,
					error: null,
					licenseList : action.payload
				}
			};
		case LICENSE_DETAILS_POPUP_FAILURE:
			return {
				...state,
				licenseDetails: {
					loading : false,
					error: action.payload,
					licenseList : []
				}
			};
		case LICENSE_UPDATE_POPUP_REQUEST:
			return {
				...state,
				licenseUpdateResponse : {
					...state.licenseUpdateResponse,
					loading: false,
					error : null
				}
			};
		case LICENSE_UPDATE_POPUP_SUCCESS:
			return {
				...state,
				licenseUpdateResponse : {
					licenseUpdateList : action.payload,
					loading: false,
					error : null
				}
			};
		case LICENSE_UPDATE_POPUP_FAILURE:
			return {
				...state,
				licenseUpdateResponse : {
					...state.licenseUpdateResponse,
					loading: false,
					error : action.payload
				}
			};
		default:
			return state;
	}
};

export const uploadLicenseReducer = (
	state = { uploadSuccess: null, loading: false, uploadError: null, licenseData: {} },
	action
) => {
	switch (action.type) {
		case UPLOAD_LICENSE:
			return {
				...state,
				loading: true,
				uploadSuccess: null,
				uploadError: null,
			};
		case UPLOAD_LICENSE_SUCCESS:
			return {
				...state,
				loading: false,
				uploadSuccess: action.msg,
				uploadError: null,
                licenseData: action.payload,
			};
		case UPLOAD_LICENSE_FAIL:
			return {
				...state,
				loading: false,
				uploadSuccess: null,
				uploadError: action.payload,
			};
		case UPLOAD_LICENSE_RESET:
			return {
				...state,
				loading: false,
				uploadSuccess: null,
				uploadError: null,
			};
		default:
			return state;
	}
};

export const licenseUpdateReducer = (
	state = {
		postLicenseError: null,
		postLicenseSuccess: null,
		patchLicenseError: null,
		patchLicenseSuccess: null,
	},
	action
) => {
	switch (action.type) {
		case LICENSE_UPDATE_PATCH:
		case LICENSE_UPDATE_POST:
			return {
				...state,
				loading: true,
				postLicenseError: false,
				postLicenseSuccess: false,
				patchLicenseError: false,
				patchLicenseSuccess: false,
			};
		case LICENSE_UPDATE_PATCH_ERROR:
			return {
				...state,
				loading: false,
				postLicenseError: false,
				postLicenseSuccess: false,
				patchLicenseError: action.payload || LICENSE_UPDATE_PATCH_ERROR,
				patchLicenseSuccess: false,
			};
		case LICENSE_UPDATE_PATCH_SUCCESS:
			return {
				...state,
				loading: false,
				postLicenseError: false,
				postLicenseSuccess: false,
				patchLicenseError: false,
				patchLicenseSuccess: action.payload || LICENSE_UPDATE_PATCH_SUCCESS,
			};
		case LICENSE_UPDATE_POST_FAIL:
			return {
				...state,
				loading: false,
				postLicenseError: action.payload || LICENSE_UPDATE_POST_FAIL,
				postLicenseSuccess: false,
				patchLicenseError: false,
				patchLicenseSuccess: false,
			};
		case LICENSE_UPDATE_POST_SUCCESS:
			return {
				...state,
				loading: false,
				postLicenseError: false,
				postLicenseSuccess: action.payload || LICENSE_UPDATE_POST_SUCCESS,
				patchLicenseError: false,
				patchLicenseSuccess: false,
			};
		case LICENSE_UPDATE_RESET:
			return {
				...state,
				loading: false,
				uploadSuccess: null,
				postLicenseError: false,
				postLicenseSuccess: false,
				patchLicenseError: false,
				patchLicenseSuccess: false,
			};
		default:
			return state;
	}
};
